import LeadFinderSubscriptionPlan, {
  UpgradeTargetPlan,
} from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";

export const planUpgradeUrls: Record<UpgradeTargetPlan, string> = {
  [LeadFinderSubscriptionPlan.ADVANCED]: "https://share.hsforms.com/1hlYOJkOnTjaHHnneDFY7gg3is1h",
  [LeadFinderSubscriptionPlan.ELITE]: "https://share.hsforms.com/1uNMqnd-hTuGLQBCE2OQlcg3is1h",
  [LeadFinderSubscriptionPlan.STARTER]: "https://share.hsforms.com/1JH9mguScSmOOW66z07HnSg3is1h",
};
